import { createBrowserRouter } from "react-router-dom";
import {
  exchangeOAuth,
  fetchBillPrivileges,
  getBillEntryPreferences,
  getCorporations,
  getPrivileges,
  login,
  userApprovals,
} from "../API/nimble";
import Dcp from "../Pages/DcpImport/Dcp";
import { getToken, setToken } from "../API/tokenStore";
import { v2Clients } from "../API/backendApi";

const billPrivileges = {
  BillEntry: "010000000000000000000000000000000370",
  BillPayment: "010000000000000000000000000000000371",
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Dcp />,
    loader: async ({ request }) => {
      try {
        const url = new URL(request.url);
        const urlInfo = url.searchParams.get("UrlInfo");
        const authId = url.searchParams.get("AuthID");
        const menuID = url.searchParams.get("MenuID");
        const headerCrpId = url.searchParams.get("corpid");
        const toBeChangeToURLV2 = await v2Clients();
        const isV2 = toBeChangeToURLV2.includes(urlInfo);
        const clientNameUrlVersion = isV2 ? "v2" : "v1";

        const { token, minutesToExpire, refAuth, curServerDateTime, userName } =
          await exchangeOAuth(clientNameUrlVersion, authId);
        setToken(token, minutesToExpire, refAuth, clientNameUrlVersion, isV2);

        const currentDate = curServerDateTime;

        const UserName = userName;
        const privileges = await getPrivileges(menuID);
        //  const privileges = { Create: true ,View: false};
        const getBillPrivileges = await fetchBillPrivileges(
          menuID,
          billPrivileges,
        );
        const preferences = await getBillEntryPreferences(menuID);
        const transactionType = 148;

        const getUserApprovalType = await userApprovals(transactionType);

        const setSelect = preferences.isLegalName
          ? { ID: "select", LegalName: "-Select-", AccountTypeName: "" }
          : { ID: "select", Name: "-Select-", AccountTypeName: "" };

        if (
          !authId ||
          !urlInfo ||
          !menuID ||
          !headerCrpId ||
          !privileges ||
          !preferences ||
          !getUserApprovalType ||
          !getBillPrivileges
        ) {
          throw new Response("Missing required params", { status: 400 });
        }

        const corporations = await getCorporations(setSelect);

        return {
          corporations,
          UserName,
          authId,
          urlInfo,
          menuID,
          headerCrpId,
          privileges,
          preferences,
          getUserApprovalType,
          billPrivileges,
          getBillPrivileges,
          setSelect,
          currentDate,
          clientNameUrlVersion,
        };
      } catch (err) {
        throw err; // rethrow so React Router knows
      }
    },
  },
]);

export default router;
